import { useIsDesktopDimension } from "../../../../../hooks/useGetDimensionGroup";

/** Возвращает условие для показа Half карточки (при mobile или tablet ширине лайаута) */
export var useShouldDisplayHalfCard = function useShouldDisplayHalfCard() {
  var isDesktop = useIsDesktopDimension();
  return !isDesktop;
};